import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetCommissionRatesArgs } from "../schemas";

const getCommissionRatesQueryKey = (args: GetCommissionRatesArgs) =>
  ["getCommissionRates", args.health_care_organization_id] as const;

export const useGetCommissionRates = (args: GetCommissionRatesArgs) => {
  const client = useApiClient();

  return useQuery(getCommissionRatesQueryKey(args), () => client.getCommissionRates(args));
};
